/**
 * Conversion factor for converting radians to degrees.
 * This is equal to 360 / (PI * 2).
 */
export const RAD2DEG: number = 180 / Math.PI;

/**
 * Conversion factor for converting degrees to radians.
 * This is equal to (PI * 2) / 360.
 */
export const DEG2RAD: number = Math.PI / 180;

/**
 * It's half the ratio of the circumference of a circle to its diameter.
 * This is equivalent to 90° degrees.
 */
export const HALF_PI: number = Math.PI / 2;

/**
 * It's one quarter the ratio of the circumference of a circle to its diameter.
 * This is equivalent to 45° degrees.
 */
export const QUARTER_PI: number = Math.PI / 4;

/**
 * It's twice the ratio of the circumference of a circle to its diameter.
 * This is equivalent to 360° degrees.
 */
export const TWO_PI: number = Math.PI * 2;

/**
 * It's twice the ratio of the circumference of a circle to its diameter.
 * This is equivalent to 360° degrees.
 * TAU is an alias for TWO_PI.
 */
export const TAU: number = TWO_PI;
